<script lang="ts" setup>
import IntermediaryTemplate from '~/components/templates/IntermediaryTemplate/IntermediaryTemplate.vue';

useAppMeta({
  title: '金融サービス仲介業に係る明示事項',
});
</script>

<template>
  <IntermediaryTemplate />
</template>
